module.exports = __webpack_public_path__ + "static/media/25488103_1703513769723807_6012913603314916457_o.5faca7d3.jpg";